import { memo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { format } from "date-fns";
import { fullDateFormatWithTime } from "@common/helpers/date";
import { timeAgo } from "@helpers/date";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { HistoryRow } from "../historyViewConfig";
import styles from "./Cell.module.scss";

export const DateCell = memo(
    ({ getValue }: CellContext<ViewTableFeatures, HistoryRow, Date>) => {
        const date = new Date(getValue());
        const relativeTime = timeAgo(date);
        const exactDate = format(date, fullDateFormatWithTime);

        return (
            <ViewTableCell className={styles.dateCell}>
                <Tooltip content={exactDate}>
                    <span>{relativeTime}</span>
                </Tooltip>
            </ViewTableCell>
        );
    },
);

DateCell.displayName = "DateCell";
